import { plotHighlights } from '@/mocks/home';

export default function PlotSection() {
  return (
    <section className="relative py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4">
            核心剧情
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            五大关键篇章
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            从警校菜鸟到王牌特工，一场关于忠诚、背叛与救赎的史诗之旅
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-background-200"></div>

          <div className="flex flex-col gap-8">
            {plotHighlights.map((point, index) => {
              const isLeft = index % 2 === 0;
              return (
                <div
                  key={index}
                  className={`flex flex-col lg:flex-row items-center gap-6 ${
                    isLeft ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  }`}
                >
                  <div className={`flex-1 ${isLeft ? 'lg:text-right' : 'lg:text-left'} w-full`}>
                    <div className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200 hover:border-primary-200 transition-all duration-300">
                      <div className="flex items-center gap-3 mb-3 lg:justify-end">
                        <span className="w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold flex-shrink-0">
                          {index + 1}
                        </span>
                        <h3 className="font-heading font-semibold text-lg text-foreground-900">
                          {point.title}
                        </h3>
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {point.description}
                      </p>
                    </div>
                  </div>

                  <div className="relative z-10 hidden lg:flex w-10 h-10 rounded-full bg-primary-500 text-background-50 items-center justify-center flex-shrink-0">
                    <i className={`${point.icon} text-base`}></i>
                  </div>

                  <div className="flex-1 hidden lg:block"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}